
import _ from 'lodash';
import { Chrome } from 'vue-color';
import Sucker from '@com/components/vue-colorpicker/Sucker.vue';
import { exchangeRgbaToObject, isRGB, isRGBA } from '@com/utils/color';
import hexToRgba from 'hex-to-rgba';

var defaultColor = '#ffffff';
var defaultGradient = {
  start: '#ff0000',
  end: '#000000'
};

export default {
  components: {
    SingleColorPicker: Chrome,
    Sucker: Sucker
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    type: {
      type: Array,
      default: function _default() {
        return ['single'];
      } // 可传 single/gradient
    },

    activeType: {
      type: String,
      default: 'single'
    },

    currentColor: {
      type: String
    },

    currentStartColor: {
      type: String
    },

    currentEndColor: {
      type: String
    },

    disabledAlpha: {
      type: Boolean,
      default: false
    },

    noColorMode: {
      type: Boolean,
      default: false
    },

    visible: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      startColor: defaultGradient.start,
      endColor: defaultGradient.end,
      currentActiveColor: 0, // 代表当前渐变色调整的类型，0: startColor, 1: endColor
      colors: defaultColor,
      currentTakeColorVisible: false,
      suckerColor: '#F5AE00'
    };
  },


  computed: {
    innerVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },

    style: function style() {
      return {
        background: this.activeType === 'single' ? this.currentColor : 'linear-gradient(90deg, ' + this.currentStartColor + ', ' + this.currentEndColor + ')'
      };
    },

    // 只要支持 EyeDropper API 就开启拾色功能，目前只有 Chrome 95 版本以上才支持
    suckerHide: function suckerHide() {
      return !window.EyeDropper;
    },
    text: function text() {
      return this.$t('basic.colorPicker');
    },
    typeMap: function typeMap() {
      return {
        single: this.text.single,
        gradient: this.text.gradient
      };
    }
  },

  watch: {
    currentColor: function currentColor(val) {
      if (this.activeType === 'single') {
        this.colors = exchangeRgbaToObject(val);
      }
    },
    currentStartColor: function currentStartColor(val) {
      this.startColor = exchangeRgbaToObject(val);
      if (this.activeType === 'gradient' && this.currentActiveColor === 0) {
        this.colors = exchangeRgbaToObject(val);
      }
    },
    currentEndColor: function currentEndColor(val) {
      this.endColor = exchangeRgbaToObject(val);
      if (this.activeType === 'gradient' && this.currentActiveColor === 1) {
        this.colors = exchangeRgbaToObject(val);
      }
    }
  },

  mounted: function mounted() {
    this.initColor(this.activeType);
  },


  methods: {
    colorToggle: function colorToggle() {
      this.currentTakeColorVisible = !this.currentTakeColorVisible;
    },
    popoverHide: function popoverHide() {
      this.currentTakeColorVisible = false;
    },
    selectSucker: function selectSucker(value) {
      this.colors = value;
      this.updateValue({ rgba: value }, false);
    },
    switchTab: function switchTab(name) {
      this.$emit('switchColorType', name);
      if (name === 'gradient') {
        this.currentActiveColor = 0;
      }
      this.initColor(name);
    },
    pickStartColor: function pickStartColor() {
      this.currentActiveColor = 0;
      this.colors = this.startColor;
    },
    pickEndColor: function pickEndColor() {
      this.currentActiveColor = 1;
      this.colors = this.endColor;
    },
    updateValue: function updateValue(value) {
      if (this.activeType === 'single') {
        this.$emit('changeColor', value);
      } else {
        if (this.currentActiveColor === 0) {
          this.$emit('changeStartColor', value);
        } else if (this.currentActiveColor === 1) {
          this.$emit('changeEndColor', value);
        }
      }
    },
    exchangeColor: function exchangeColor(val) {
      if (_.isString(val)) {
        if (isRGBA(val) || isRGB(val)) {
          return val;
        }
        return exchangeRgbaToObject(hexToRgba(val));
      } else if (_.isArray(val)) {
        if (val.length === 3) {
          return {
            r: val[0],
            g: val[1],
            b: val[2],
            a: 1
          };
        } else if (val.length === 4) {
          return {
            r: val[0],
            g: val[1],
            b: val[2],
            a: val[3]
          };
        }
      }
    },
    initColor: function initColor(tab) {
      if (tab === 'single') {
        this.colors = this.exchangeColor(this.currentColor || defaultColor);
      } else if (tab === 'gradient') {
        this.colors = this.exchangeColor(this.currentStartColor || defaultGradient.start);
        if (this.currentStartColor) {
          this.startColor = this.exchangeColor(this.currentStartColor || defaultGradient.start);
        }
        if (this.currentEndColor) {
          this.endColor = this.exchangeColor(this.currentEndColor || defaultGradient.end);
        }
      }
    }
  }
};